import React from 'react';
import BackupOutlinedIcon from '@mui/icons-material/BackupOutlined';
import {
  PreviewHeader, PreviewLines, PreviewPage, PreviewPanel, PreviewTable,
} from '../../../components/access-denied/preview/PreviewParts';

/** Prévia falsa de Backup e dados para a tela de bloqueio (dados de exemplo fixos). */
const ExportLockedPreview = () => (
  <PreviewPage>
    <PreviewHeader icon={<BackupOutlinedIcon />} title="Backup e dados" subtitle="Cópias diárias e exportação completa" />
    <PreviewPanel title="Último backup">
      <PreviewLines widths={[70, 52]} />
    </PreviewPanel>
    <PreviewPanel title="Exportar meus dados">
      <PreviewTable
        columns={['Pedido em', 'Situação', 'Tamanho']}
        rows={[
          ['01/01', 'Concluída', '000 MB'],
          ['01/02', 'Concluída', '000 MB'],
        ]}
      />
    </PreviewPanel>
  </PreviewPage>
);

export default ExportLockedPreview;
